import { lazy, Suspense } from 'react';
import { AdminLayout } from 'components/themes/admin';

const JobPosition = lazy(() => import('modules/admin/master/JobPosition'));

const JobPositionPage = (props) => (
  <AdminLayout>
    <Suspense fallback={null}>
      <JobPosition />
    </Suspense>
  </AdminLayout>
);

export default JobPositionPage;
